var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32147 8.60566C2.15228 8.38854 2.15228 8.09407 2.32147 7.87695L3.69356 8.241C4.72024 9.40723 8.18849 12.9746 12.1929 12.9746C16.2059 12.9746 19.6669 9.40906 20.6922 8.24184L22.0643 7.87717C22.2337 8.09407 22.2337 8.38877 22.0643 8.60585C21.8857 8.83448 17.6292 14.2094 12.1929 14.2094C6.7566 14.2094 2.49992 8.83452 2.32147 8.60566Z",
    fill: "#C5CBE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L12.0111 19",
    stroke: "#C5CBE1",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1379 14.9297L18.362 17.6686",
    stroke: "#C5CBE1",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9834 14.9297L5.75929 17.6686",
    stroke: "#C5CBE1",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12L23.1213 14.1213",
    stroke: "#C5CBE1",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12134 12L1.00002 14.1213",
    stroke: "#C5CBE1",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.916ef939317378836d9e030b44c7e5a4.svg";
export { ForwardRef as ReactComponent };